"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleContext = void 0;
const react_1 = require("react");
exports.ScheduleContext = react_1.createContext(undefined);
//# sourceMappingURL=schedule-context.js.map